import { render, staticRenderFns } from "./togetherAiUpgrade.vue?vue&type=template&id=181f371f&scoped=true"
import script from "./togetherAiUpgrade.vue?vue&type=script&lang=js"
export * from "./togetherAiUpgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181f371f",
  null
  
)

export default component.exports